var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',{attrs:{"include":_vm.keepAliveInclude}},[(_vm.loaded)?_c(_vm.keepAliveCompName,{tag:"component"}):_vm._e(),(!_vm.keepAliveCompName && _vm.loaded)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }